export var unhandledEntry = Symbol("ts-enum-util:unhandledEntry");
export var handleNull = Symbol("ts-enum-util:handleNull");
export var handleUndefined = Symbol("ts-enum-util:handleUndefined");
export var handleUnexpected = Symbol("ts-enum-util:handleUnexpected");